<kodit-card-container
  [isTitleWithIcon]="true"
  titleIcon="fa-regular fa-blender"
  [showDivider]="true"
>
  <div card-title-with-icon>Režim proizvoda</div>

  <div class="p-d-flex p-flex-column gap-6" card-body>
    <p-selectButton
      [options]="opcije"
      [(ngModel)]="izabraniRezim"
      optionLabel="label"
      optionValue="value"
      (onChange)="onRezimChange($event.value)"
    ></p-selectButton>

    <small class="rezim-opis" *ngIf="izabraniRezim === rezimi.NA_LAGER">
      Proizvod se pravi unapred preko radnog naloga i vodi se na lageru.
    </small>
    <small class="rezim-opis" *ngIf="izabraniRezim === rezimi.PRI_PRODAJI">
      Sastojci se razdužuju automatski pri izdavanju fiskalnog računa. Proizvod
      se ne vodi na lageru i nije dostupan na dokumentima veleprodaje i ručnom
      radnom nalogu.
    </small>
  </div>
</kodit-card-container>
